(function ($, window, document, undefined) {
  $.fn.bulletChart = function (chartValues) {
    var values = $.extend(
      {
        totalBudgetOrFee: 0,
        percentComplete: 0,
        spentValue: 0,
        earnedValue: 0,
        billedValue: 0,
        paidValue: 0,
        isOverhead: false,
        height: 25,
      },
      chartValues
    );

    var bulletChartsContainer = this.outerHeight(values.height);
    var budgetOrFeeLabel = values.isOverhead ? "Budget" : "Fee";
    var feeRemainingOrOverFeeValue =
      values.totalBudgetOrFee - values.spentValue;
    var isOver = feeRemainingOrOverFeeValue < 0;
    var totalWidthValue = isOver ? values.spentValue : values.totalBudgetOrFee;
    var spentOrFeeValue =
      values.spentValue < values.totalBudgetOrFee
        ? values.spentValue
        : values.totalBudgetOrFee;

    if (!bulletChartsContainer.hasClass("bulletChartsContainer")) {
      bulletChartsContainer.addClass("bulletChartsContainer");
    }

    if (values.totalBudgetOrFee == 0 && feeRemainingOrOverFeeValue == 0) {
      bulletChartsContainer.empty().css("visibility", "hidden");
      return;
    }

    var bulletChart = $("<div>").addClass("bulletChart");
    bulletChartsContainer.empty().append(bulletChart);

    var feeRemainingOrOverFee = $("<div>")
      .addClass("toolTipChartSection")
      .addClass(!isOver ? "feeRemaining" : "overFee")
      .attr(
        "toolTipValue",
        (!isOver
          ? budgetOrFeeLabel + " Remaining: "
          : "Over " + budgetOrFeeLabel + ": ") +
          parseCurrency(Math.abs(feeRemainingOrOverFeeValue))
      );
    bulletChart.append(feeRemainingOrOverFee);

    var spentOrFeePercentage = spentOrFeeValue / totalWidthValue;
    var spentOrFee = $("<div>")
      .addClass("toolTipChartSection")
      .addClass("spentOrFee")
      .css("width", spentOrFeePercentage * 100 + "%")
      .attr(
        "toolTipValue",
        (!isOver ? "Spent: " : budgetOrFeeLabel + ": ") +
          parseCurrency(spentOrFeeValue)
      );
    bulletChart.append(spentOrFee);

    feeRemainingOrOverFee.css("left", spentOrFeePercentage * 100 + "%");

    var earnedValuePercentage = values.earnedValue / spentOrFeeValue;
    var earnedValue = $("<div>")
      .addClass("toolTipChartSection")
      .addClass("earnedValue")
      .css("width", earnedValuePercentage * 100 + "%")
      .attr(
        "toolTipValue",
        "Earned Value: " + parseCurrency(values.earnedValue)
      );
    spentOrFee.append(earnedValue);

    if (values.billedValue > 0) {
      addTarget(
        values.billedValue,
        "#000",
        "Billed: " + parseCurrency(values.billedValue),
        bulletChart,
        totalWidthValue
      );
    }

    if (values.paidValue > 0) {
      addTarget(
        values.paidValue,
        "#ccc",
        "Paid: " + parseCurrency(values.paidValue),
        bulletChart,
        totalWidthValue
      );
    }

    $.fn.bulletChart.resizeBulletCharts(bulletChartsContainer);

    var bulletChartToolTip = $("<div>").addClass("bulletChartToolTip");
    bulletChartsContainer.append(bulletChartToolTip);

    bulletChart
      .mouseenter(function (e) {
        bulletChartToolTip.show();
        relocateTooltip(bulletChartToolTip, e);
      })
      .mouseleave(function () {
        var oldHighlighted = $(".toolTipVisible");
        if (oldHighlighted.length > 0) {
          oldHighlighted.removeClass("toolTipVisible");

          if (oldHighlighted.attr("originalBackgroundColor")) {
            oldHighlighted.css(
              "backgroundColor",
              oldHighlighted.attr("originalBackgroundColor")
            );
          }
        }
        bulletChartToolTip.hide();
      })
      .mousemove(function (e) {
        var self = e.target;

        if (
          $(self).hasClass("toolTipChartSection") &&
          !$(self).hasClass("toolTipVisible")
        ) {
          var oldHighlighted = $(".toolTipVisible");
          if (oldHighlighted.length > 0) {
            oldHighlighted.removeClass("toolTipVisible");

            if (oldHighlighted.attr("originalBackgroundColor")) {
              oldHighlighted.css(
                "backgroundColor",
                oldHighlighted.attr("originalBackgroundColor")
              );
            }
          }

          $(self).addClass("toolTipVisible");
          bulletChartToolTip.html($(self).attr("toolTipValue"));

          $(self)
            .parents(".toolTipChartSection")
            .each(function (index, item) {
              if ($(item).attr("originalBackgroundColor")) {
                $(item).css(
                  "backgroundColor",
                  $(item).attr("originalBackgroundColor")
                );
              }
            });

          if (!$(self).hasClass("noHighlight")) {
            if (!$(self).attr("originalBackgroundColor")) {
              $(self).attr(
                "originalBackgroundColor",
                $(self).css("backgroundColor")
              );
            }

            $(self).css(
              "backgroundColor",
              getHighlightColor($(self).attr("originalBackgroundColor"))
            );
          }
        }

        relocateTooltip(bulletChartToolTip, e);
      });

    return bulletChartsContainer;
  };

  $.fn.bulletChart.resizeBulletCharts = function (root) {
    var charts = root ? $("div.bulletChart", root) : $("div.bulletChart");

    charts.each(function (index, item) {
      //if both markers are non-zero and they overlap one another, then split the two markers in half so both are visible

      var numMarkers = $(item).find(".bulletChartMarker").length;
      if (
        numMarkers == 2 &&
        doMarkersOverlap(
          $($(item).find(".bulletChartMarker")[0]),
          $($(item).find(".bulletChartMarker")[1])
        )
      ) {
        var newTopOffset = parseInt(
          $($(item).find(".bulletChartMarker")[0]).css("top")
        );
        var newMarkerHeight =
          ($(item).height() - 2 * newTopOffset) / numMarkers;
        $(item)
          .find(".bulletChartMarker")
          .each(function (i, marker) {
            $(marker).height(newMarkerHeight);
            $(marker).css("top", newTopOffset);
            newTopOffset += newMarkerHeight;
          });
      } else {
        $(item).find(".bulletChartMarker").css({ height: "76%", top: "12%" });
      }
    });
  };

  function doMarkersOverlap(marker1, marker2) {
    //note: widerMarker and narrowerMarker can be the same width
    var widerMarker = marker1;
    var narrowerMarker = marker2;

    if (marker2.width() > marker1.width()) {
      widerMarker = marker2;
      narrowerMarker = marker1;
    }

    var LB1 = narrowerMarker.position().left;
    var RB1 = LB1 + narrowerMarker.width();

    var LB2 = widerMarker.position().left;
    var RB2 = LB2 + widerMarker.width();

    if (
      (LB2 > LB1 && LB2 < RB1) ||
      (LB1 > LB2 && RB1 < RB2) ||
      (RB2 > LB1 && RB2 < RB1) ||
      (LB2 == LB1 && RB2 == RB1)
    ) {
      return true;
    }

    return false;
  }

  function addTarget(
    targetValue,
    hexColor,
    toolTipValue,
    parentObject,
    parentValue
  ) {
    var targetPercentage = targetValue / parentValue;
    var targetOffset = -1.5;
    if (targetPercentage == 0) {
      targetOffset = 0;
    } else if (targetPercentage >= 1) {
      targetOffset = -3;
    }

    $("<div>")
      .addClass("noHighlight")
      .addClass("toolTipChartSection")
      .addClass("bulletChartMarker")
      .css({
        background: hexColor,
        left: targetPercentage * 100 + "%",
        "margin-left": parseFloat(targetOffset) + "px",
      })
      .attr("toolTipValue", toolTipValue)
      .appendTo(parentObject);
  }

  function relocateTooltip(bulletChartToolTip, e) {
    var toolTipLeft = e.pageX + 6 - $(document).scrollLeft();
    var toolTipTop = e.pageY - 29 - $(document).scrollTop();
    var pageContainerWidth = $(window).width();

    if ($("div.middle-column").length > 0) {
      pageContainerWidth = $("div.middle-column")[0].clientWidth;
    }

    if (
      bulletChartToolTip.outerWidth() + toolTipLeft + 4 >
      pageContainerWidth
    ) {
      toolTipLeft +=
        pageContainerWidth -
        (bulletChartToolTip.outerWidth() + toolTipLeft + 4);
    }
    bulletChartToolTip.css({ left: toolTipLeft, top: toolTipTop });
  }

  //it takes hex (3 or 6 digit) or rgb, so just pass it in!
  function getHighlightColor(colorString) {
    var lightRatio = 1.25;

    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
    result = result
      ? "#" +
        componentToHex(parseInt(result[1], 16) * lightRatio) +
        componentToHex(parseInt(result[2], 16) * lightRatio) +
        componentToHex(parseInt(result[3], 16) * lightRatio)
      : null;

    if (result == null) {
      result = colorString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      result = result
        ? "#" +
          componentToHex(result[1] * lightRatio) +
          componentToHex(result[2] * lightRatio) +
          componentToHex(result[3] * lightRatio)
        : null;
    }

    return result;
  }

  function componentToHex(c) {
    c = parseInt(c);
    if (c > 255) {
      c = 255;
    }
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  function parseCurrency(val) {
    return "$" + val.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  }
})(jQuery, window, document);
